/* Star Ratings on Product Cards */
(function() {
  var reviewData = {"ashwagandha-gummies-stress-relief-focus-sleep-support":{"avg":"4.6","count":10},"cayenne-pepper-herbal-liquid-drops-with-hawthorn-beet-root-turmeric-vitamin-d3-k2":{"avg":"4.8","count":11},"feminine-balance-gummies-womens-health-immune-support":{"avg":"4.7","count":21},"liquid-morning-multivitamin-hair-growth":{"avg":"5.0","count":3},"magnesium-complex-1000mg-8-forms-glycinate-citrate-malate-taurate":{"avg":"4.9","count":22},"multi-collagen-peptides":{"avg":"4.8","count":24},"oregano-oil-black-seed-oil-softgels":{"avg":"4.7","count":15},"organic-lions-mane-mushroom-powder":{"avg":"5.0","count":6},"organic-maca-root-liquid-drops-with-ashwagandha":{"avg":"4.7","count":14},"oxyshred-ultra-concentration-pre-workout-cosmic-blast":{"avg":"4.6","count":16},"premium-feminine-balance-gummies-digestion-immunity":{"avg":"4.9","count":8},"probiotic-gummies-for-women-cranberry-ph-balance-digestive-health":{"avg":"4.8","count":5},"pumpkin-seed-oil-with-saw-palmetto":{"avg":"4.7","count":19},"pure-himalayan-shilajit-gummies-3000mg-with-85-trace-minerals":{"avg":"4.9","count":23},"saffron-advanced-10-in-1-complex":{"avg":"4.8","count":13},"sea-moss-16-in-1-supplement":{"avg":"4.9","count":7},"triple-strength-omega-3-fish-oil":{"avg":"4.8","count":4},"vitamin-d3-10-000-iu-k2-mk-7-softgels-with-coconut-oil":{"avg":"4.9","count":9},"womens-creatine-monohydrate-powder":{"avg":"4.8","count":17},"womens-multivitamin-21-in-1-complete-daily-complex":{"avg":"4.9","count":12}};

  function injectStars() {
    var links = document.querySelectorAll('a[href*="/products/"]');
    var done = [];
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var href = link.getAttribute('href') || '';
      var parts = href.split('/products/');
      if (parts.length < 2) continue;
      var handle = parts[1].split('?')[0].split('#')[0];
      if (!handle || !reviewData[handle]) continue;
      var card = link.closest('product-card') || link.closest('[class*=card]');
      if (!card || card.querySelector('.vh-card-stars') || done.indexOf(card) !== -1) continue;
      done.push(card);
      var d = reviewData[handle];

      // Target the <product-price> custom element directly (Horizon theme)
      var priceContainer = card.querySelector('product-price');
      // Fallback for other themes: find outermost element with price class
      if (!priceContainer) {
        var priceEls = card.querySelectorAll('[class*=price]');
        if (priceEls.length > 0) priceContainer = priceEls[priceEls.length - 1];
      }
      if (!priceContainer) continue;

      var full = Math.floor(parseFloat(d.avg));
      var half = (parseFloat(d.avg) - full) >= 0.3;
      var s = '';
      for (var j = 0; j < 5; j++) {
        if (j < full) s += '\u2605';
        else if (j === full && half) s += '\u2605';
        else s += '\u2606';
      }
      var div = document.createElement('div');
      div.className = 'vh-card-stars';
      div.innerHTML = '<span class="vh-stars-icons">' + s + '</span> <span class="vh-stars-text">(' + d.count + ')</span>';
      priceContainer.parentNode.insertBefore(div, priceContainer.nextSibling);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { injectStars(); setTimeout(injectStars, 1000); });
  } else { injectStars(); setTimeout(injectStars, 1000); }
  document.addEventListener('shopify:section:load', injectStars);
  new MutationObserver(function(m) {
    if (m.some(function(x) { return x.addedNodes.length > 0; })) setTimeout(injectStars, 100);
  }).observe(document.body, { childList: true, subtree: true });
})();
